export default {
  path: '/lvy-week-card-recharge-rule',
  component: () => import('./LVYWeekCardRechargeRule'),
  meta: {
    title: '活动规则',
    designWidth:750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
